import Box from '@mui/material/Box';
import React from 'react';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Cards from '../components/Cards/Cards';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import BigCard from '../components/Cards/BigCard';
import ContentCard from '../components/Cards/ContentCard';
import { useTranslation } from '../hook/Translation';


export default function EmfaceFacialMuscleLiftTone() {
const { t } = useTranslation();
    const data = [
        {
            header: t('face'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 17.png`,
            description: t('emface_facial_muscle_lift_tone.faceDesc'),
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('neck'),
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 18.png`,
             description: t('emface_facial_muscle_lift_tone.neckDesc'),
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        }
    ]

    const accodirons = [
        {
            title: t('what'),
            content:  t('emface_facial_muscle_lift_tone.what'),
        },
        {
            title: t('how'),
            content: t('emface_facial_muscle_lift_tone.how'),
        },
        {
            title: t('benefits'),
            content: t('emface_facial_muscle_lift_tone.benefits'),
        },
        {
            title: t('zone'),
            content: t('emface_facial_muscle_lift_tone.zone'),
        },
        {
            title: t('pairs'),
            content: t('emface_facial_muscle_lift_tone.pairs'),
        },
        {
            title: t('when_expected_results'),
            content: t('emface_facial_muscle_lift_tone.expected_results'),
        },
        {
            title: t('results'),
            content: t('emface_facial_muscle_lift_tone.results'),
        },
    ];

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
             title: t('time'),
            description: t('emface_facial_muscle_lift_tone.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('emface_facial_muscle_lift_tone.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description:t('emface_facial_muscle_lift_tone.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description:t('emface_facial_muscle_lift_tone.sessions'),
        }
    ];


    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69faf9759f35f8.64540600.png`} height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    titleSize={{ md: 8, xs: 12 }}
                    data={{
                        type: t('skinTherapies'),
                        title: t('emface_facial_muscle_lift_tone.mainTitle'),
                        description: t('emface_facial_muscle_lift_tone.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMFACE – Lifting & Tonifikim i Muskujve të Fytyrës (RF + HIFES)")}`,
                        learn: "",
                        price: `${t('price_session')} €390\n4 ${t('price_package')}: €1,170\n6 ${t('price_package')}: €1,680\n\nEmface TMJ: €245\n4 ${t('price_package')}: €735`,
                        doctorIncluded: true
                    }}
                />
            </Box>
            <Box marginTop={{md: '107px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{md: '104px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{md: '90px', xs: '50px'}}>
                <Box sx={{ height: { md: 600, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMFACE – Lifting & Tonifikim i Muskujve të Fytyrës (RF + HIFES)")}`,
                            type: t('emface_facial_muscle_lift_tone.tech'),
                            title: 'RF + HIFESTM',
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageSize: {md: 6, xs: 12},
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f889d7536cf5.05167857.png`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('emface_facial_muscle_lift_tone.techDesc')
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container gap={{md: '80px', xs: '30px'}} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{md: '100px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Grid bgcolor={'#F0F0EF'} marginTop={{md: '136px', xs: '50px'}} className="generalContainer" marginX={'auto'} container paddingX={{ md: '66px', xs: '20px' }} paddingY={{ md: '36px', xs: '20px' }} gap={'34px'}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" fontWeight={600} fontSize={{ md: '1.125rem', xs: '1rem' }} color="text.secondary">{t('emface_facial_muscle_lift_tone.results2Title')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" fontSize={{ md: '1.875rem', xs: '1.125rem' }} color="text.secondary" fontWeight={600}>{t('emface_facial_muscle_lift_tone.results2Desc')}</Typography>
                </Grid>
            </Grid>

            <Grid container gap={{md: '32px', xs: '50px'}} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{md: '90px', xs: '50px'}}>
                <Grid size={12}>
                    <Grid container spacing={4} justifyContent={'center'}>
                        <Grid size={12}>
                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('emface_facial_muscle_lift_tone.treatment_zone_title')}</Typography>
                            <Typography textAlign={'center'} marginX={'auto'} variant="body1" color="text.secondary" marginTop={'22px'} width={{md: '994px', xs: '100%'}} fontSize={'1rem'}>{t('emface_facial_muscle_lift_tone.treatment_zone_desc')}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 6 }} />
                </Grid>
            </Grid>

            <Box paddingBottom={{md: '156px', xs: '50px'}} marginTop={{md: '152px', xs: '50px'}} paddingTop={{md: '68px', xs: '50px'}} bgcolor={'#f0f0ef'}>
                <Box className="generalContainer" marginX={'auto'} gap={{md: '82px', xs: '50px'}} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08ee034e332.15570718.jpg`,
                            type: t('pairing'),
                            title: t('emface_facial_muscle_lift_tone.card1Title'),
                            description: t('emface_facial_muscle_lift_tone.card1Desc'),
                            direction: { md: 'row-reverse', xs: 'column-reverse' },
                            learn: "/body/exion-rf-body-skin-tightening",
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION BODY")}`
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08deb8424f8.41614833.jpg`,
                            type: t('pairing'),
                            title: t('emface_facial_muscle_lift_tone.card2Title'),
                            description: t('emface_facial_muscle_lift_tone.card2Desc'),
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box>

        </Box>
    )
}